import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery, useQueryClient } from '@tanstack/react-query'

import { useErrorHandler } from '@/features/bidding/hooks/useErrorHandler'
import { pqClient } from '@/features/prequalification/localControl/endpoints/pqClient'
import type { LocalPqResourceSet } from '@/features/prequalification/localControl/types'
import type { UseQueryOptions } from '@/types/queries'

export const GET_LOCAL_PQ_RESOURCE_SET_API_ID = 'GET_LOCAL_PQ_RESOURCE_SET'

export type UseLocalPqResourceSetQueryParams = {
  resourceSetId: string
}

export type UseLocalPqResourceSetQueryResult = Omit<UseQueryResult, 'data'> & {
  resourceSet: LocalPqResourceSet | null
}

export function useLocalPqResourceSetQuery(
  params: UseLocalPqResourceSetQueryParams,
  options?: UseQueryOptions<LocalPqResourceSet>,
): UseLocalPqResourceSetQueryResult {
  const { data, ...queryResult } = useQuery({
    ...options,
    queryFn: () => pqClient.getResourceSet(params.resourceSetId),
    queryKey: [GET_LOCAL_PQ_RESOURCE_SET_API_ID, params],
  })

  useErrorHandler(queryResult.isError)

  return {
    ...queryResult,
    resourceSet: data ?? null,
  }
}

export function useInvalidateLocalPqResourceSetQuery() {
  const queryClient = useQueryClient()

  return () => queryClient.invalidateQueries({ queryKey: [GET_LOCAL_PQ_RESOURCE_SET_API_ID] })
}
